import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import axios from 'axios';
import { Check, Loader2, AlertCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

export default function PayPalCheckout({ amount, description, invitationId, tier, extras = [], currency = 'EUR', onSuccess }) {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  if (!CLIENT_ID) return <div className="text-sm text-red-600">PayPal non configurato.</div>;

  const createOrder = async () => {
    setStatus('processing');
    setMessage('');
    try {
      const res = await axios.post(`${API}/paypal/orders`, {
        amount,
        description,
        invitation_id: invitationId,
        tier,
        extras,
        currency,
      });
      return res.data.id;
    } catch (e) {
      setStatus('error');
      setMessage('Errore nella creazione ordine');
      throw e;
    }
  };

  const onApprove = async (data) => {
    try {
      const res = await axios.post(`${API}/paypal/orders/${data.orderID}/capture`);
      if (res.data.paid) {
        setStatus('success');
        setMessage('Pagamento completato!');
        if (onSuccess) onSuccess(res.data);
      } else {
        setStatus('error');
        setMessage(`Stato: ${res.data.status}`);
      }
    } catch (e) {
      setStatus('error');
      setMessage('Errore durante il pagamento');
    }
  };

  return (
    <div className="w-full">
      {status === 'success' ? (
        <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-green-50 border border-green-200 text-green-800">
          <Check size={18} /> <span className="text-sm">{message}</span>
        </div>
      ) : (
        <>
          <PayPalScriptProvider options={{ 'client-id': CLIENT_ID, currency, intent: 'capture' }}>
            <PayPalButtons
              key={currency}
              style={{ layout: 'vertical', color: 'gold', shape: 'pill', label: 'pay', height: 45 }}
              createOrder={createOrder}
              onApprove={onApprove}
              onError={(err) => { setStatus('error'); setMessage('Errore PayPal'); console.error(err); }}
              onCancel={() => { setStatus('idle'); setMessage(''); }}
            />
          </PayPalScriptProvider>
          {status === 'processing' && (
            <div className="flex items-center gap-2 text-sm text-[color:var(--ink-soft)] mt-3">
              <Loader2 size={14} className="animate-spin" /> Elaborazione…
            </div>
          )}
          {status === 'error' && message && (
            <div className="flex items-center gap-2 text-sm text-red-600 mt-3">
              <AlertCircle size={14} /> {message}
            </div>
          )}
        </>
      )}
    </div>
  );
}
